module.exports = __webpack_public_path__ + "img/logo@2x.7cbab71f.png";